/* Shopify handles authentication; this module only enhances the landing page. */
(() => {
  'use strict';

  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const tabs = [...root.querySelectorAll('[data-account-tabs] [data-account-mode]')];
    const panel = root.querySelector('[data-account-panel]');
    const form = root.querySelector('[data-account-form]');
    if (!form || !panel) return;
    const email = form.querySelector('[data-account-email]');
    const error = form.querySelector('[data-account-error]');
    const submit = form.querySelector('[data-account-submit]');
    const returnField = form.querySelector('[data-account-return]');
    const defaultReturn = returnField.value;
    const tablist = root.querySelector('[data-account-tabs]');
    tablist.setAttribute('role', 'tablist');
    panel.setAttribute('role', 'tabpanel');
    form.noValidate = true;
    for (const tab of tabs) {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panel.id);
    }

    function clearError() {
      error.textContent = '';
      email.removeAttribute('aria-invalid');
    }

    function setMode(next, updateUrl = false, focusEmail = false) {
      const mode = next === 'signin' ? 'signin' : 'signup';
      document.title = mode === 'signin' ? root.dataset.signinTitle : root.dataset.signupTitle;
      for (const tab of tabs) {
        const selected = tab.dataset.accountMode === mode;
        tab.setAttribute('aria-selected', String(selected));
        tab.setAttribute('aria-current', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected) panel.setAttribute('aria-labelledby', tab.id);
      }
      for (const copy of root.querySelectorAll('[data-account-copy]')) {
        copy.hidden = copy.dataset.accountCopy !== mode;
      }
      clearError();
      if (updateUrl) {
        const url = new URL(location.href);
        // Shopify reserves "view" for alternate templates. Keep the page mode separate.
        url.searchParams.set('mode', mode);
        history.replaceState(null, '', url);
      }
      if (focusEmail) email.focus();
    }

    function safeReturnPath(value) {
      // Accept only local, root-relative destinations; never accept protocol-relative URLs.
      if (!value || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u0020]/.test(value)) return defaultReturn;
      try {
        const parsed = new URL(value, location.origin);
        const decodedPath = decodeURIComponent(parsed.pathname);
        if (parsed.origin !== location.origin || decodedPath.startsWith('//') || decodedPath.includes('\\')) return defaultReturn;
        if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?customer_authentication\//i.test(decodedPath)) return defaultReturn;
        if (parsed.pathname === location.pathname) return defaultReturn;
        return parsed.pathname + parsed.search + parsed.hash;
      } catch (_) {
        return defaultReturn;
      }
    }

    for (const link of root.querySelectorAll('[data-account-mode]')) {
      link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        setMode(link.dataset.accountMode, true, !tabs.includes(link));
      });
    }
    for (const [index, tab] of tabs.entries()) {
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + 1) % tabs.length;
        setMode(tabs[next].dataset.accountMode, true);
        tabs[next].focus();
      });
    }
    email.addEventListener('input', clearError);
    form.addEventListener('submit', event => {
      if (submit.disabled) { event.preventDefault(); return; }
      email.value = email.value.trim();
      if (!email.validity.valid) {
        event.preventDefault();
        error.textContent = email.value ? error.dataset.invalid : error.dataset.empty;
        email.setAttribute('aria-invalid', 'true');
        email.focus();
        return;
      }
      clearError();
      returnField.value = safeReturnPath(new URL(location.href).searchParams.get('return_to'));
      submit.disabled = true;
      form.setAttribute('aria-busy', 'true');
      submit.querySelector('[data-submit-label]').hidden = true;
      submit.querySelector('[data-submit-loading]').hidden = false;
      // Native GET navigation passes login_hint to Shopify. No email is stored or logged here.
    });
    window.addEventListener('pageshow', () => {
      submit.disabled = false;
      form.removeAttribute('aria-busy');
      submit.querySelector('[data-submit-label]').hidden = false;
      submit.querySelector('[data-submit-loading]').hidden = true;
    });
    setMode(new URL(location.href).searchParams.get('mode') || root.dataset.defaultMode);
  }

  for (const root of document.querySelectorAll('[data-rossi-account]')) initialize(root);
  document.addEventListener('shopify:section:load', event => {
    for (const root of event.target.querySelectorAll('[data-rossi-account]')) initialize(root);
  });
})();
